import React, { FC } from 'react';

import { IconProps } from 'types/components';

import Icon from './Icon';

const WifiOff: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M21.16 23a.83.83 0 0 1-.59-.25L2.24 4.42a.83.83 0 0 1 1.18-1.18l18.33 18.33a.82.82 0 0 1 0 1.15.83.83 0 0 1-.59.28Zm-2.69-9a.85.85 0 0 0-.1-1.18 10.14 10.14 0 0 0-2.07-1.36.84.84 0 0 0-.74 1.5 8.28 8.28 0 0 1 1.74 1.14.8.8 0 0 0 .54.18.84.84 0 0 0 .63-.28Zm-12.31.25a.83.83 0 0 1-.83-.83.85.85 0 0 1 .3-.64 9.71 9.71 0 0 1 4.7-2.13.83.83 0 0 1 1 .68.82.82 0 0 1-.68.95 8.47 8.47 0 0 0-3.96 1.82.82.82 0 0 1-.53.15Zm14.65-2.92a.86.86 0 0 1-.55-.21A12.47 12.47 0 0 0 11 8a.84.84 0 0 1-.12-1.67 14.29 14.29 0 0 1 10.5 3.5.84.84 0 0 1 .05 1.17.9.9 0 0 1-.62.28Zm-17.57 0a.82.82 0 0 1-.89-.77.85.85 0 0 1 .28-.69 13.9 13.9 0 0 1 4.16-2.5.83.83 0 0 1 1.08.46.82.82 0 0 1-.44 1.06 12.66 12.66 0 0 0-3.66 2.2.83.83 0 0 1-.53.24ZM15 17.26a.84.84 0 0 1-.49-.16 4.15 4.15 0 0 0-4.82 0 .83.83 0 0 1-1.16-.18.84.84 0 0 1 .2-1.16 5.84 5.84 0 0 1 6.77 0 .84.84 0 0 1 .18 1.17.85.85 0 0 1-.68.33Zm-3 3.24a.84.84 0 0 1-.84-.84.8.8 0 0 1 .8-.82.83.83 0 0 1 .83.82.84.84 0 0 1-.79.84Z" />
  </Icon>
);

export default WifiOff;
